<mat-expansion-panel [disabled]="translationMode">
  <mat-expansion-panel-header>
    <mat-panel-title [style.color]="translationMode ? '' : '#595c5f'">
      <mat-icon style="margin-right: 10px;">format_color_fill</mat-icon>
      {{'pass.widgetStyle' | translate}}
      <!-- <span class="badge custom-badge rounded-pill ms-1">Beta</span> -->
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="widgetStyleForm" class="m-1">

    <mat-card class="mb-4">
      <mat-tab-group animationDuration="300ms">
        <mat-tab label="{{'pass.lightTheme' | translate}}">

          @if (userHasBetaWidgetRole) {
            <mat-form-field appearance="outline" class="w-100 px-2 my-2" [hidden]="lightbackgroundImageURL">
              <mat-label>{{'pass.backgroundImageURL' | translate}}</mat-label>
              <input formControlName="lightbackgroundImageURL" type="text" matInput placeholder="{{'pass.backgroundImageURL' | translate}}">
            </mat-form-field>
          }

          <div [class.mt-4]="!userHasBetaWidgetRole" [hidden]="lightBackground && lightTitle && lightSubtitle && lightPrimary && lightAccent">
            <div class="d-flex flex-row-reverse px-2 mb-3">
              <button mat-button class="secondary-gray-button" (click)="resetLightColors()">
                <mat-icon>format_color_reset</mat-icon> {{'pass.resetColors' | translate}}
              </button>
            </div>
            <mat-list>
              <mat-list-item role="listitem" [hidden]="lightBackground ">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.background | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="lightBackground" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_lightBackground) {
                      <span id="invalid_lightBackground" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
              <mat-divider [hidden]="lightTitle"></mat-divider>

              <mat-list-item role="listitem" [hidden]="lightTitle">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.title | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="lightTitle" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_lightTitle) {
                      <span id="invalid_lightTitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
              <mat-divider [hidden]="lightSubtitle"></mat-divider>

              <mat-list-item role="listitem" [hidden]="lightSubtitle">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.subtitle | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="lightSubtitle" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_lightSubtitle) {
                      <span id="invalid_lightTitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
              <mat-divider [hidden]="lightPrimary"></mat-divider>

              <mat-list-item role="listitem" [hidden]="lightPrimary">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.primary | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="lightPrimary" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_lightPrimary) {
                      <span id="invalid_lightTitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
              <mat-divider [hidden]="lightAccent"></mat-divider>

              <mat-list-item role="listitem" [hidden]="lightAccent">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.accent | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="lightAccent" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_lightAccent) {
                      <span id="invalid_lightAccent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-tab>
        <mat-tab label="{{'pass.darkTheme' | translate}}">

          @if (userHasBetaWidgetRole) {
            <mat-form-field appearance="outline" class="my-2 px-2 w-100" [hidden]="darkbackgroundImageURL">
              <mat-label>{{'pass.backgroundImageURL' | translate}}</mat-label>
              <input formControlName="darkbackgroundImageURL" type="text" matInput placeholder="{{'pass.backgroundImageURL' | translate}}">
            </mat-form-field>
          }

          <div [class.mt-2]="!userHasBetaWidgetRole" [hidden]="darkBackground && darkTitle && darkSubtitle && darkPrimary && darkAccent">
            <div class="d-flex flex-row-reverse px-2 mb-3">
              <button mat-button class="secondary-gray-button" (click)="resetDarkColors()">
                <mat-icon>format_color_reset</mat-icon> {{'pass.resetColors' | translate}}
              </button>
            </div>
            <mat-list>
              <mat-list-item role="listitem" [hidden]="darkBackground">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.background | translate}}</div>
                  <label class="d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="darkBackground" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_darkBackground) {
                      <span id="invalid_darkBackground" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
              <mat-divider [hidden]="darkTitle"></mat-divider>

              <mat-list-item role="listitem" [hidden]="darkTitle">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.title | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="darkTitle" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_darkTitle) {
                      <span id="invalid_darkTitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>

              <mat-divider [hidden]="darkSubtitle"></mat-divider>

              <mat-list-item role="listitem" [hidden]="darkSubtitle">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.subtitle | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="darkSubtitle" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_darkSubtitle) {
                      <span id="invalid_darkSubtitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>

              <mat-divider [hidden]="darkPrimary"></mat-divider>

              <mat-list-item role="listitem" [hidden]="darkPrimary">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.primary | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="darkPrimary" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_darkPrimary) {
                      <span id="invalid_darkPrimary" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>

              <mat-divider [hidden]="darkAccent"></mat-divider>

              <mat-list-item role="listitem" [hidden]="darkAccent">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{colorLabels.accent | translate}}</div>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="darkAccent" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_darkAccent) {
                      <span id="invalid_darkAccent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card>

    @if (userHasBetaWidgetRole) {
      <mat-form-field appearance="outline" class="ps-1 w-100" [hidden]="backgroundImageAnchor">
        <mat-label>{{'pass.backgroundImageAnchor' | translate}}</mat-label>
        <mat-select formControlName="backgroundImageAnchor" class="input-group">
          @for (option of anchorOptions; track option) {
            <mat-option value="{{option.type}}">{{option.translate | translate}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <div class="mt-4">
      <mat-form-field appearance="outline" class="w-50 pe-1">
        <mat-label>{{'pass.paddingTop' | translate}}</mat-label>
        <input formControlName="paddingTop" type="number" matInput min="0" placeholder="{{'pass.paddingTop' | translate}}">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-50 ps-1">
        <mat-label>{{'pass.paddingBottom' | translate}}</mat-label>
        <input formControlName="paddingBottom" type="number" matInput min="0" placeholder="{{'pass.paddingBottom' | translate}}">
      </mat-form-field>
    </div>


    <!-- @if(!contentAlignment) { -->
    <mat-form-field appearance="outline" class="mt-1 w-100" [hidden]="contentAlignment">
      <mat-label>{{'pass.contentAlignment' | translate}}</mat-label>
      <mat-select formControlName="contentAlignment" class="input-group">
        <mat-option value="leading"><mat-icon>format_align_left</mat-icon>{{'pass.leading' | translate}}</mat-option>
        <mat-option value="center"><mat-icon>format_align_center</mat-icon>{{'pass.center' | translate}}</mat-option>
        <mat-option value="trailing"><mat-icon>format_align_right</mat-icon>{{'pass.trailing' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- }   -->
  </form>
</mat-expansion-panel>
